import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchProperties, Property } from '../../store/reducers/propertiesSlice';
import './MyProperties.css';

const MyProperties: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const userId = localStorage.getItem('userId') || '';

  const { properties, isLoading, error } = useAppSelector(
    state => state.properties         
  );          


  useEffect(() => {
    if (userId) {
      dispatch(fetchProperties({ limit: 25, offset: 0, userId }));
    }
  }, [dispatch, userId]);

  const goToDetails = (p: Property) => {
    const qs = new URLSearchParams({
      id: p.buildingId,
      name: p.name,
      lat: p.location.lat.toString(),
      lng: p.location.lng.toString(),
      price: p.price.toString(),
    }).toString();
    navigate(`/Property-Details?${qs}`);
  };
  return (
    <div className="mp-container">
      <div className="mp-card">
        <header className="mp-header">
          <FaArrowLeft
            className="mp-back-icon"
            onClick={() => navigate(-1)}
          />
          <h2 className="mp-title">My Properties</h2>
        </header>

        <div className="mp-body">
          {isLoading && <div className="mp-loading">Loading…</div>}
          {error    && <div className="mp-error">Error: {error}</div>}
          {!isLoading && !error && properties.length === 0 && (
            <div className="mp-empty">No properties found</div>
          )}
          

          {!isLoading && !error && properties.length > 0 && (
            <ul className="mp-list">
              {properties.map(p => p.buildingId && (
                <li key={p.buildingId} className="mp-item">
                  <div className="mp-details">
                    <h3 className="mp-name">{p.name}</h3>
                    <p className="mp-price">Price: ${p.price?.toFixed(2)}</p>
                    {p.location.lat && p.location.lng && <p className="mp-coords">
                      📍 {p.location.lat.toFixed(4)}, {p.location.lng.toFixed(4)}
                    </p>}
                  </div>
                  <button
                    className="mp-more-button"
                    onClick={() => goToDetails(p)}
                    disabled={isLoading || !p.buildingId}
                  >
                    More Details
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyProperties;
